import { TprmRequirementType } from '@evidentid/tprm-portal-lib/models/entity-details';

export function getEvaluationErrorsMapKey(requirementType: TprmRequirementType, instanceId?: string | null): string {
    return instanceId ? `${requirementType}-${instanceId}` : requirementType;
}
